import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MetaPreviewData } from '../../../../../../../models/meta-template/preview-interfaces/meta-preview-data.interface';
import { MetaCreativeComponent } from '../../../preview-common/meta-creative/meta-creative.component';
import { MetaPreviewCopy, TruncatedCopy } from '../../../preview-common/meta-preview-copy';

/**
 * Instagram search results ("Sažetak rezultata pretraživanja"): a full-screen
 * reel opened from a search, under the searched term, with the reel actions in
 * a column on the right. "[Search term]" is Meta's own placeholder.
 */
@Component({
  selector: 'app-meta-instagram-search-results',
  imports: [CommonModule, MetaCreativeComponent],
  templateUrl: './instagram-search-results.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: [
    '../../../preview-common/story/meta-story-styles.scss',
    './instagram-search-results.component.scss',
  ]
})
export class MetaInstagramSearchResultsPreviewComponent {
  @Input() data!: MetaPreviewData;

  readonly accountName = MetaPreviewCopy.INSTAGRAM_ACCOUNT_NAME;
  readonly avatar = MetaPreviewCopy.AVATAR;

  /** One line of caption before " ...": the first paragraph, cut on a word at 41 characters. */
  get primaryText(): TruncatedCopy {
    return MetaPreviewCopy.firstParagraph(MetaPreviewCopy.primaryText(this.data), 41);
  }
}
